// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*purgecss start ignore*/\n:root{\n  --header-height-sm:80px;\n  --header-height:96px\n}\n.fagron-slider .slick-list{\n  margin:0 -10px\n}\n@media (min-width: 768px){\n.fagron-slider .slick-list{\n    margin:0 -25px\n}\n}\n.fagron-slider .slick-slide{\n  margin:0 10px\n}\n@media (min-width: 768px){\n.fagron-slider .slick-slide{\n    margin:0 25px\n}\n}\n\n/*purgecss end ignore*/", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
